import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, Observable, retry } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FetchClientInfo_V1Req, SegmentDetailsReq } from '../models/request.model';
import { APICallingLimit } from './constant.service';
import { handleHttpError } from './handle-http-error.service';

@Injectable({
  providedIn: 'root'
})
export class DerivativeDetailsService {

  constructor(private http: HttpClient) { }

  FetchClientInfo_V1(
    FetchClientInfo_V1Req: FetchClientInfo_V1Req
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
      ReqSource: FetchClientInfo_V1Req.head.AppSource,      
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'storeUploadDocument_New',
        FetchClientInfo_V1Req,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  segmentDetails(
    SegmentDetailsReq: SegmentDetailsReq
  ): Observable<any> {
   
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/details',
        SegmentDetailsReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }
  
}